import { render, staticRenderFns } from "./vat-manage.vue?vue&type=template&id=9e2b6c60&scoped=true&"
import script from "./vat-manage.vue?vue&type=script&lang=js&"
export * from "./vat-manage.vue?vue&type=script&lang=js&"
import style0 from "./vat-manage.vue?vue&type=style&index=0&id=9e2b6c60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2b6c60",
  null
  
)

export default component.exports